import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { MCP_CREDENTIALS_API } from '../../constants/central-api';

export default async function get_all_connected_mcp_api_call(active?: boolean) {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  if (!shopSlug || shopSlug === '') return false;

  const requestInfo: RequestInfo = {
    url: `${MCP_CREDENTIALS_API(shopSlug)}${active ? '/active' : ''}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_ALL_CONNECTED_MCP_LIST';
  const customMsg = 'Connected MCP Data Loaded Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  if (!response.success) {
    return false;
  }
  if (res.actionType === actionType && response.success === true) {
    if (response.data === null) {
      return [];
    } else {
      const data = response?.data;

      //* Format the data to add manual credentials to the accounts list
      const formatted_data = data.map((item: any) => {
        const newItem = JSON.parse(JSON.stringify(item));

        if (newItem.credentials && newItem.accounts) {
          for (const key in newItem.credentials) {
            if (newItem.credentials.hasOwnProperty(key)) {
              const credentialValue = newItem.credentials[key];

              if (
                newItem.accounts.hasOwnProperty(key) &&
                Array.isArray(newItem.accounts[key])
              ) {
                const accountList = newItem.accounts[key];

                const isValuePresent = accountList.some(
                  (account: any) => account.OptionValue === credentialValue
                );

                if (!isValuePresent) {
                  accountList.push({
                    OptionName: credentialValue,
                    OptionValue: credentialValue,
                  });
                }
              }
            }
          }
        }
        return newItem;
      });
      return formatted_data;
    }
  }
}
